import React from "react";
import { Button, Grid, Header, Icon } from "semantic-ui-react";
import useCustomerView from "../../hooks/useCustomerView";
import CustomerEventsTable from "@common/components/shared/CustomerReview/CustomerEventsTable";
import CustomerReviewFiltersDesktop from "@common/components/shared/CustomerReview/CustomerReviewFiltersDesktop";
import useCustomerReviewsFilters from "../../common/components/hooks/useCustomerReviewsFilters";
import { useSelector } from "react-redux";

const CustomerEvents = () => {
  const {
    selectedRecord,
    interactionsColumns,
    customerEvents,
    onRecordClick,
    fullName,
  } = useCustomerView();
  const { showFilters, toggleFilters } = useCustomerReviewsFilters();
  const { optionShowComplianceAlerts } = useSelector((state) => state.logIn);

  return (
    <Grid className="pt-1 w-100">
      <Grid.Row className="flex-row-center">
        <Header className="pt-1 pl-1">{fullName} - Compliance Records</Header>
        <Button
          type="button"
          onClick={toggleFilters}
          color={showFilters ? "black" : ""}
          inverted={!showFilters}
          className="w-3 h-3 p-0 m-0 border"
        >
          <Icon
            style={{ padding: "0 0 0 0.35em" }}
            name="sliders horizontal"
            color={showFilters ? "" : "black"}
            size="large"
          />
        </Button>
      </Grid.Row>
      <Grid.Row>
        <CustomerReviewFiltersDesktop />
      </Grid.Row>
      <Grid.Row className="p-1 flex">
        <CustomerEventsTable
          headings={
            optionShowComplianceAlerts
              ? interactionsColumns
              : interactionsColumns.filter((x) => x.name !== "triggeredAlert")
          }
          records={customerEvents}
          selectedRecord={selectedRecord}
          onRecordClick={onRecordClick}
        />
      </Grid.Row>
    </Grid>
  );
};

export default CustomerEvents;
